import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'sf-range-widget',
  templateUrl: './sf-range-widgets.component.html'
})
export class RangeWidgetComponent extends ControlWidget {
}



// WEBPACK FOOTER //
// ./src/app/schema-form/components/defaultwidgets/range/sf-range-widget.component.ts